import React, { useState,useEffect } from 'react';
import {Navigate} from 'react-router-dom'
import { useSelector } from 'react-redux'
import SessionService from '../../services/SessionService';
import { openLoginModal } from '../../slices/authSlice';
import { useDispatch } from 'react-redux';
function SecureRoute({children}){
    const dispatch = useDispatch()
    const [isLoggedIn, setIsLoggedIn] = useState(SessionService.isLoggedIn);

    useEffect(() => {
        setIsLoggedIn(SessionService.isLoggedIn);
        if(!SessionService.isLoggedIn){
            dispatch(openLoginModal())
            return
        }
    }, [dispatch]);



    return isLoggedIn?children:<Navigate to="/"/>
}

export default SecureRoute